import React from 'react'
import './footer.css';

const Footer = () => {

    return (
        <div className="footer">
            <div style={{textAlign: 'center', paddingTop: 13, color: "#777"}}>This is my blog footer :)</div>
        </div>
    
    )
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js